function AutomaticExportSaving(automaticExport) {
  if (!this instanceof AutomaticExportSaving) {
    return new AutomaticExport();
  }

  this.automaticExport = automaticExport;

  /**
   * Validate the parameters before saving. Only the necessary paramters are validated!
   * @returns {boolean}
   */
  this.checkParams = function () {
    const autoExport = this.automaticExport;

    if (!autoExport.selectedPartnerGroup) {
      snackbar.show({
        message: "Bitte einen Dienstleister für den Export auswählen",
      });
      return false;
    }

    if (!autoExport.selectedPartner) {
      snackbar.show({
        message: "Bitte einen Partner für den Export auswählen",
      });
      return false;
    }

    if (!autoExport.selectedForm) {
      snackbar.show({ message: "Bitte ein Formular für den Export auswählen" });
      return false;
    }

    if (
      !autoExport.selectedCSVExport &&
      !autoExport.selectedPDFExport &&
      !autoExport.selectedXMLExport
    ) {
      snackbar.show({
        message:
          "Bitte mindestens eine Export-Konfiguration (CSV, PDF oder XML) auswählen",
      });
      return false;
    }

    return true;
  };

  /**
   * Send an API-request to save the current parameters
   */
  this.saveParams = function () {
    const autoExport = this.automaticExport;
    const exportName = autoExport.exportNameInput.value;
    const exportFilename = autoExport.exportFilenameInput.value;
    const zipPassword = autoExport.zipPasswordInput.value;

    const exportConfig = {
      // config for exporting the customers
      partnergroup: autoExport.selectedPartnerGroup.id,
      partner: autoExport.selectedPartner.id,
      form: autoExport.selectedForm.id,
      location: autoExport.selectedLocation
        ? autoExport.selectedLocation.id
        : null,
      employee: autoExport.selectedEmployee
        ? autoExport.selectedEmployee.id
        : null,
      epaper: autoExport.epaperCheckbox.checked,
      print: autoExport.printCheckbox.checked,
      without: autoExport.withoutCheckbox.checked,
    };

    const params = {
      name: exportName,
      exportConfig: exportConfig,
      exportAsExcel: autoExport.excelCheckbox.checked,
      singleUpload: autoExport.singleUploadCheckbox.checked,
      csvConfig: autoExport.selectedCSVExport
        ? autoExport.selectedCSVExport
        : null,
      pdfConfig: autoExport.selectedPDFExport
        ? autoExport.selectedPDFExport
        : null,
      xmlConfig: autoExport.selectedXMLExport
        ? autoExport.selectedXMLExport
        : null,
      active: this.automaticExport.json.data.active,
    };

    if (exportFilename) {
      params.filename = exportFilename;
    }

    if (zipPassword) {
      params.zipPassword = zipPassword;
    }

    const that = this;
    const xhr = Network.openXHR(
      "PUT",
      `${API_PATH}automaticExport/${autoExport.json.data.id}/`
    );
    xhr.onerror = () => {
      snackbar.show({
        message: "Beim Speichern ist ein unbekannter Fehler aufgetreten.",
      });
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        that.automaticExport.setJSONData(JSON.parse(this.responseText));
        snackbar.show({ message: "Die Daten wurden erfolgreich gespeichert." });
      }
    };

    xhr.send(JSON.stringify(params));
  };
}
